module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    on: {
      "mouseover": function($event) {
        return _vm.onArrow()
      },
      "mouseout": function($event) {
        return _vm.hideArrow()
      }
    }
  }, [_c('ol', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dots === 'none' ? false : true),
      expression: "dots === 'none'? false:true"
    }],
    class: _vm.dotsClasses
  }, [_vm._l((_vm.slides.length), function(n) {
    return [_c('li', {
      key: n.index,
      class: [n - 1 === _vm.currentIndex ? 'active' : ''],
      on: {
        "click": function($event) {
          return _vm.$_dotsEvent('click', n - 1)
        },
        "mouseover": function($event) {
          return _vm.$_dotsEvent('hover', n - 1)
        }
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    class: [(_vm.prefixCarouselClass + "-inner")]
  }, [_vm._t("default")], 2), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showArrow),
      expression: "showArrow"
    }],
    class: (_vm.prefixCarouselClass + "-control-prev"),
    attrs: {
      "href": "javascript:void(0);",
      "role": "button",
      "data-slide": "prev"
    },
    on: {
      "click": function($event) {
        return _vm.$_arrowEvent(-1)
      }
    }
  }, [_c('i', {
    class: (_vm.prefixCarouselClass + "-control-prev-icon " + (_vm.$constants.CLASS_MAIN) + " " + (_vm.$constants.PREFIX_ICON_CLASS) + "chevron-left")
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showArrow),
      expression: "showArrow"
    }],
    class: (_vm.prefixCarouselClass + "-control-next"),
    attrs: {
      "href": "javascript:void(0);",
      "role": "button",
      "data-slide": "next"
    },
    on: {
      "click": function($event) {
        return _vm.$_arrowEvent(1)
      }
    }
  }, [_c('i', {
    class: (_vm.prefixCarouselClass + "-control-next-icon " + (_vm.$constants.CLASS_MAIN) + " " + (_vm.$constants.PREFIX_ICON_CLASS) + "chevron-right")
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fee3902c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/carousel.vue
// module id = 421
// module chunks = 0